<template>
    <b-modal v-if="!loading" id="floor_form" ref="floor_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">

        <template v-slot:modal-title>
            {{ !edit ? 'Add New Floor' : 'Edit Floor' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form>
            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Name" class="has-float-label">
                        <template v-slot:label>
                            <span>Name <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.name" :class="{'border-danger': 'name' in errors}"
                                      @input="'name' in errors ? delete errors.name : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!'name' in errors"
                                                 v-text="'name' in errors ? errors.name[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Facilities" class="has-float-label">
                        <template v-slot:label>
                            <span>Facilities <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateFacility" v-model="selected.facility" :options="facilities"
                                  :border-danger="'facility_id' in errors"/>

                        <b-form-invalid-feedback :state="!'facility_id' in errors"
                                                 v-text="'facility_id' in errors ? errors.facility_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('floor_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitFloor">Submit</state-button>

            <state-button v-else variant="primary" :click="updateFloor">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
    import { mapGetters } from "vuex";
    import StateButton from "../../../../../components/Common/StateButton";
    import moment from "moment";

    export default {
        name: "FloorFormModal",

        components: {
            StateButton,
        },

        props: [
            'edit',
        ],

        data() {
            return {
                loading: true,
                selected: {
                    facility: [],
                },
            };
        },

        computed: {
            ...mapGetters({
                form: 'getFloorForm',
                errors: 'getFloorErrors',
                facilities: 'getSelectFacilities',
            }),
        },

        watch: {
            form() {
                if (this.edit) {
                    this.selected.facility = this.form.select_facility;
                }
            },
        },

        mounted() {
            this.getFormData();
        },

        methods: {
            resetForm() {
                this.$store.commit('setFloorForm');

                this.selected.facility = [];
            },

            updateFacility(field) {
                if (field) {
                    this.form.facility_id = field.facility_id;
                } else {
                    this.form.facility_id = '';
                }
                'facility_id' in this.errors ? delete this.errors.facility_id : '';
            },

            async getFormData() {
                await this.$store.dispatch('fetchSelectFacilities');

                return this.loading = false;
            },

            hideModal(refname) {
                this.$refs[refname].hide();
            },

            submitFloor() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('submitFloor', this.form)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.resetForm();

                                this.$notify('success filled', 'Success!', 'Added new floor!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('floor_form');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },
            updateFloor() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('updateFloor', this.form)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.resetForm();

                                this.$notify('success filled', 'Success!', 'Updated the floor!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('floor_form');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },
        },
    }
</script>

<style scoped>

</style>
